<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/hahualong@3x.png" alt="">
            <div class="company">哈尔滨华隆蓝狐育种有限公司</div>
          </div>
          <div class="labInfo">
            <span>狐狸</span>
            <span>对外贸易经营</span>
            <span>貂的驯养繁殖</span>
          </div>
          <div class="companyInfo">
            <!-- <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/daqing1.jpg" alt=""> -->
            <div class="companyWord">哈尔滨华隆蓝狐育种有限公司成立于2015年，隶属于哈尔滨华隆集团，位于哈尔滨市双城区永胜乡永乐村，项目总投资1亿元，蓝狐种群存栏8400余只，其中：种母狐8000只，种公狐400只，年存栏量约5.5万-6万只。项目建设占地30万平方米，一期场区占地面积11.895万平方米，主要分为种狐养殖区、公狐养殖区、饲料加工区、仓库区、办公区五大功能区，总建筑面积：11.895万平米。棚舍建设面积：10.915万平方米、办公室及饲料加工等设施7100平方米、场区道路2000平方米、粪便处理设施700平方米和无害化处理设施、相关设备购置。二期预留场地：绿化林带、盐碱地改造等。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/ha1.jpg" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
          <div class="info"> 裘皮、饲料、养殖、皮草</div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.hualongfeed.com/cpzs">http://www.hualongfeed.com/cpzs</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>哈尔滨 双城市永胜乡永乐村</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';
</style>
